module.exports = __webpack_public_path__ + "static/img/slide_8.ac9dd3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/careers/slider/slide_8.png
// module id = J5Fd
// module chunks = 0